export const IS_CONTROL_WIDGET = Symbol()
